var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block"},[_c('Icon',{attrs:{"slot":"extra","type":_vm.type,"color":_vm.icolor,"size":"40"},slot:"extra"}),_vm._v(" "),_c('label',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),(_vm.value)?_c('h3',{staticClass:"value"},[_vm._v(_vm._s(_vm.value))]):_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-238cb5b6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/activity-block.vue
// module id = null
// module chunks = 